import { Target, Upload, CheckCircle } from "lucide-react";
import { EyebrowPill } from "@/components/shared/EyebrowPill";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StepCard } from "@/components/shared/StepCard";

const steps = [
  {
    icon: Target,
    step: "01",
    title: "Build Your TAS and Map Your Scope",
    description: "Import your qualifications and units from Training.gov.au. ComplyHub validates your scope, checks packaging rules, pulls labour market data, and guides you through building a Standards-aligned TAS — phase by phase.",
  },
  {
    icon: Upload,
    step: "02",
    title: "Upload and Organise Your Documents",
    description: "Upload your existing policies, procedures, and records in bulk. The AI reads each file, extracts metadata, assigns compliance triggers, and routes documents to the correct repository automatically.",
  },
  {
    icon: CheckCircle,
    step: "03",
    title: "Stay Audit-Ready Every Day",
    description: "Once your system is live, compliance becomes genuinely simple. Monitor gaps, track trainer currency, log governance meetings, and generate your full audit pack whenever ASQA calls.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-white text-ch-acai">
      <div className="container">
        <div className="text-center mb-14 animate-fade-up">
          <EyebrowPill>Getting Started</EyebrowPill>
          <SectionHeading className="mb-5">How It Works</SectionHeading>
          <p className="text-lg text-ch-acai/75 max-w-2xl mx-auto">
            Getting set up takes some work — but once your system is running, staying audit-ready becomes genuinely simple. Here's the path.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className={`relative animate-fade-up animate-delay-${(index + 1) * 100}`}
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-20 w-[calc(100%-4rem)] h-0.5 bg-gradient-to-r from-ch-purple to-ch-fuchsia opacity-20" />
              )}
              <div className="relative z-10">
                <StepCard
                  icon={step.icon}
                  label={`Step ${step.step}`}
                  title={step.title}
                >
                  {step.description}
                </StepCard>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
